import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BackendServiceService {

  constructor() { }
  apiLocalUrl = "https://tamronlanka.uc.r.appspot.com/";
  apiSystemAdminURL  = "https://tamronlanka.uc.r.appspot.com/system/admin/";
  //apiLocalUrl ="https://buycartradebackend.de.r.appspot.com/";
  //apiSystemAdminURL = "https://buycartradebackend.de.r.appspot.com/system/admin/";
 
 // apiLocalUrl = "http://localhost:8080/";
 //apiSystemAdminURL = "http://localhost:8080/system/admin/";

 
}
